import Global from "@/globals/globals";

const LOCAL_HOSTNAMES = ["localhost", "127.0.0.1"];

const parseServerAddress = (value: unknown): URL | null => {
  if (typeof value !== "string") return null;
  let text = value
    .trim()
    .replace(/\/webrtcPeer\s*["']?\s*$/i, "")
    .replace(/["'\s]+$/, "")
    .trim();
  const doubled = text.match(/^https?:\/\/(https?:\/\/.+)$/i);
  if (doubled) text = doubled[1];
  if (!/^https?:\/\//i.test(text)) {
    if (!text || /^https?$/i.test(text)) return null;
    text = `https://${text}`;
  }
  try {
    const url = new URL(text);
    return url.hostname ? url : null;
  } catch {
    return null;
  }
};

const allowedHosts = (): Set<string> => {
  const hosts = new Set<string>();
  const configured = String(import.meta.env.VITE_MEDIA_SERVER_HOSTS || "").split(",");
  for (const entry of [Global.serviceIP, ...configured]) {
    const url = parseServerAddress(entry);
    if (url) hosts.add(url.host);
  }
  return hosts;
};

export const resolveMediaServerUrl = (address?: unknown): string | null => {
  const url = parseServerAddress(address || Global.serviceIP);
  if (!url || !allowedHosts().has(url.host)) return null;
  const protocol = LOCAL_HOSTNAMES.includes(url.hostname) ? "http:" : "https:";
  return `${protocol}//${url.host}`;
};
